export default "__VITE_ASSET__C76C30Z3__"